import { useGetAuthSessionQuery } from '@/api/serverApi'
import EditPasswordForm from '@/components/forms/profile/EditPasswordForm'
import EditProfileForm from '@/components/forms/profile/EditProfileForm'
import EditProfilePictureForm from '@/components/forms/profile/EditProfilePictureForm'
import { Navbar, SettingsNavigation } from '@/components/header'
import { LoadingSpinner, Meta } from '@cfs-fixings/shared'

const EditProfilePage = () => {
  const textSpec = {
    title: 'Profile',
    subtitle: 'Manage and update your profile settings',
  }

  const { data, isLoading } = useGetAuthSessionQuery()

  return <>
    <Meta title="Edit Profile" />

    <Navbar content={<SettingsNavigation />} topbar={<div className="flex" />}>
      <div className="flex flex-col items-center w-full gap-[30px]">
        <div className="flex flex-col items-start w-full max-w-[615px]">
          <h1 className="text-2xl leading-[28.8px] font-semibold">{textSpec.title}</h1>
          <h2 className="text-sm leading-[19.6px] font-medium">{textSpec.subtitle}</h2>
        </div>

        <div className="border-t border-grey-100 w-full max-w-[615px]"></div>
        {
          data?.data && !isLoading
            && <div className="flex flex-col items-center gap-[30px] w-full max-w-[615px]">

              <EditProfilePictureForm user={data?.data} />

              <div className="w-full border-t border-grey-100"></div>

              <EditProfileForm user={data?.data} />

              <div className="w-full border-t border-grey-100"></div>

              <EditPasswordForm />
            </div>
        }

        {
          !data?.data && isLoading
            && <div className="w-full flex items-center justify-center">
              <LoadingSpinner className="h-4 w-4" />
            </div>
        }
      </div>
    </Navbar>
  </>
}

export default EditProfilePage
